export default function CheckboxCell({ value, onChange, readOnly = false }) {
  return (
    <div className={`w-full h-full flex items-center justify-center transition-colors min-h-[40px] ${readOnly ? '' : 'cursor-pointer hover:bg-white/5'}`}>
      <input
        type="checkbox"
        checked={!!value}
        disabled={readOnly}
        onChange={(e) => onChange(e.target.checked)}
        className="w-4 h-4 rounded border-border bg-transparent accent-accent cursor-pointer disabled:cursor-not-allowed disabled:opacity-60"
      />
    </div>
  );
}
